import type { Channel } from 'types/masterData'

import { combineUrl } from './combineUrl'

type ProductPriceUrlProps = {
	productId: string
	countryISO: string
	channel: Channel
}

export function getClientProductPriceUrl({
	productId,
	countryISO,
	channel,
}: ProductPriceUrlProps): URL {
	if (!process.env.NEXT_PUBLIC_ORCHESTRATOR_DOMAIN) {
		throw new Error('NEXT_PUBLIC_ORCHESTRATOR_DOMAIN is not defined')
	}

	const basePath = '/v3/prices/products'

	const searchParams = new URLSearchParams({
		channelId: channel,
		countryIso: countryISO,
		productId,
	})

	searchParams.sort()

	return combineUrl(
		process.env.NEXT_PUBLIC_ORCHESTRATOR_DOMAIN,
		basePath,
		searchParams
	)
}
